// extracted by mini-css-extract-plugin
export default {"cls1":"YapilyConnectFields-ContentRow_cls1__JMFcF","cls2":"YapilyConnectFields-ContentRow_cls2__ZnUgG YapilyConnectFields-ContentRow_cls1__JMFcF"};